module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.item.title) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.item.latitude) + ", " + _vm._s(_vm.item.longitude) + ")")])]), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.item.location))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b1e16c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vauto-projectName.vue
// module id = 416
// module chunks = 3